import { FormControl, FormLabel, Select } from '@wegroup/design-system';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Option } from '../../../../../../types/Form';

interface Props {
  options: Option[];
}

const OfferCarFormControls: React.FC<React.PropsWithChildren<Props>> = ({
  options,
}) => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <FormControl>
      <FormLabel htmlFor="franchise">{t('Franchise')}</FormLabel>
      <Controller
        control={control}
        name="franchise"
        render={({ field: { onChange, value, ...restField } }) => (
          <Select
            placeholder={t('Choose an option')}
            onChange={(value) => onChange(JSON.parse(value.target.value))}
            value={JSON.stringify(value)}
            {...restField}
          >
            {options.map(({ label, value }, index) => (
              <option key={index} value={JSON.stringify(value)}>
                {label}
              </option>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default OfferCarFormControls;
